
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiModelAdd extends Vue {
  @Prop({
    default: () => {
      return [];
    },
    type: Array
  })
  private devTypeList!: object[];
  private modalShow = false;
  private loading = true;
  private modalTitle = i18n.t("ratamanage.rateDetails");

  private oprAcFeeInfos: object[] = [];
  private tableListMiniShow = false;

  private slotFlagText = [
    i18n.t("ratamanage.jian"),
    i18n.t("ratamanage.feng"),
    i18n.t("ratamanage.ping"),
    i18n.t("ratamanage.gu")
  ];
  private tableListLarge: object[] = [];

  private tableColumnsLarge: object[] = [
    {
      title: i18n.t("addRatamanage.timeValue"),
      key: "time",
      resizable: true,
      minWidth: 180
    },
    {
      title: i18n.t("addRatamanage.slotFlag"),
      key: "slotFlag",
      resizable: true,
      width: 180,
      slot: "slotFlag"
    },
    {
      title: i18n.t("addRatamanage.slotElecPrice"),
      key: "slotElecPrice",
      resizable: true,
      width: 180
    },
    {
      title: i18n.t("addRatamanage.slotServicePrice"),
      key: "slotServicePrice",
      resizable: true,
      width: 180
    }
  ];
  private tableListBigShow = true;
  private tableListMini: object[] = [];

  private tableColumnsMini: object[] = [
    {
      title: i18n.t("addRatamanage.timeValue"),
      key: "time",
      resizable: true,
      minWidth: 200
    },
    {
      title: i18n.t("addRatamanage.slotElecPrice"),
      key: "slotElecPrice",
      resizable: true,
      width: 220
    },
    {
      title: i18n.t("addRatamanage.slotServicePrice"),
      key: "slotServicePrice",
      resizable: true,
      width: 220
    }
  ];
  private modelList: object[] = [];

  public open(item: objAny, key: string) {
    console.log(key);
    this.modalShow = true;

    let list: objAny[] = [];
    if (key === "ac") {
      this.modalTitle = i18n.t("ratamanage.acRate");
      list = item.oprAcFeeInfos;
      let time: string[] = [];
      list.map((unit: objAny) => {
        time = [unit.beginTime, unit.endTime];
        unit.time = this.joinDate(time);
      });
    } else if (key === "dc") {
      this.modalTitle = i18n.t("ratamanage.dcRate");
      list = item.oprDcFeeInfos;
      let time: string[] = [];
      list.map((unit: objAny) => {
        time = [unit.beginTime, unit.endTime];
        unit.time = this.joinDate(time);
      });
    }
    console.log(list);
    if (list.length > 1) {
      this.tableListBigShow = true;
      this.tableListLarge = list;
      this.tableListMiniShow = false;
    } else {
      this.tableListBigShow = false;
      this.tableListMini = list;
      this.tableListMiniShow = true;
    }
  }
  /**
   * 分开时间08:00,12:00
   * @param data [{timeQuantum: ['12:30-15:40']}],
   *@param  processData [{beginTime:1230,endTime:1540}]
   */
  public splitDate(data: objAny[]) {
    console.log(data);
    // let dataArray: objAny[];
    // return dataArray;
  }

  /**
   * 把例如1230转为12:30
   * @param data 08：00
   * @param processData
   */
  convertStringToTimes(data: string | number) {
    const hour = String(Math.floor(Number(data) / 100)).padStart(2, "0");
    const min = String(Number(data) % 100).padStart(2, "0");
    const time = hour + ":" + min;
    return time;
  }
  /**
   * 合并时间 08:00-12:00
   */
  joinDate(data: string[]) {
    let timeArr = "";
    if (data.length > 0) {
      timeArr =
        this.convertStringToTimes(data[0]) +
        "-" +
        this.convertStringToTimes(data[1]);
      return timeArr;
    }
  }
  public closeModal(): void {
    this.modalShow = false;
  }
  mounted() {
    this.$emit("getChild", this);
  }
}
